<template lang="pug">
  #overlay-blood-pressure-with-selfie
    icon(data="@icon/overlay/evidence-guideline-bp.svg")
    icon(data="@icon/overlay/evidence-guideline-face.svg")
</template>

<script>
export default {
  props: {},

  data() {
    return {}
  },

  computed: {},

  watch: {},

  methods: {},

  components: {},
}

/* Computed ---------------------------------------------------- */
/* Watch ------------------------------------------------------- */
/* Methods ----------------------------------------------------- */
</script>
